import {ResolvingLitElement} from "../../lib/ResolvingLitElement.js";

export class Page extends ResolvingLitElement {

}